import api from './api';

export const getSalesDashboard = () => api.get('/sales/dashboard');
